import { AutogenModelUserSysHealth, AutogenRowUserSysHealth } from "./autogen/AutogenModelUserSysHealth";

export class ModelUserSysHealth extends AutogenModelUserSysHealth<RowUserSysHealth> {
	constructor() {
		super(RowUserSysHealth);
	}
}

export class RowUserSysHealth extends AutogenRowUserSysHealth {
}